import { render, staticRenderFns } from "./ansCollFromRegFinalForm.vue?vue&type=template&id=092fdf00&scoped=true&"
import script from "./ansCollFromRegFinalForm.vue?vue&type=script&lang=js&"
export * from "./ansCollFromRegFinalForm.vue?vue&type=script&lang=js&"
import style0 from "./ansCollFromRegFinalForm.vue?vue&type=style&index=0&id=092fdf00&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "092fdf00",
  null
  
)

export default component.exports